import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireCjs } from "/home/runner/work/style-to-js/style-to-js/cjs/index.js";
var cjsExports = requireCjs();
export { cjsExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(cjsExports);